// src/components/FullScreenLoading/index.jsx
import React from 'react'
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material'
import { brown } from '@mui/material/colors'
import { useTheme } from '@mui/material/styles'
import ArbolEcLogo from '../../assets/images/arbol-ec/arbol_ec_logo.png'

const FullScreenLoading = ({
  open = true,
  message = 'Cargando autenticación...',
  showIcon = true,
}) => {
  const theme = useTheme()

  return (
    <Backdrop open={open} sx={{ zIndex: theme => theme.zIndex.modal + 1 }}>
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '32px 24px',
          textAlign: 'center',
          minWidth: '320px',
          maxWidth: '400px',
          boxShadow: theme.shadows[24],
        }}>
        {showIcon ? (
          <Box
            sx={{
              position: 'relative',
              width: '150px',
              height: '150px',
              margin: '0 auto 16px auto',
            }}>
            <Box position="relative" top={34}>
              <Box component="img" src={ArbolEcLogo} width={80} height={80} />
            </Box>
            <CircularProgress
              size={150}
              thickness={2}
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                color: theme.palette.primary.main,
              }}
            />
          </Box>
        ) : (
          <CircularProgress
            size={60}
            thickness={3.5}
            sx={{
              color: theme.palette.primary.main,
              mb: 2,
            }}
          />
        )}

        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: brown[800],
            fontSize: '1.2rem',
            fontFamily: theme.typography.fontFamily,
          }}>
          {message}
        </Typography>
      </Box>
    </Backdrop>
  )
}

export default FullScreenLoading
